/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { cloneDeep } from 'lodash';

import { FitinsurAPI, MessageCenter } from 'utils';

function handleInitialAdjustments({
  questionnaire
}) {
  return questionnaire.map(question => {
    let answerQuestion = question.answerOptions?.find(ansOpt => ansOpt.idAnswerOption == question.idAnswerOption)

    if (answerQuestion && [38].includes(answerQuestion.idDomain) && question.idQuestionRoot) {
      questionnaire = questionnaire.map(qst => {
        if ([question.idQuestionRoot].includes(qst.idQuestion)) {
          qst.behaviorObject.isRefusedByHiddenQuestions = true;
        }
        return qst;
      })
    }

    return question;
  })
}

function groupMultipleFieldQuestions({
  mainIdQuestion,
  questionnaire,
  handleQuestionsInitialAdjustments,
  permissions
}) {
  const groupQuestions = [];

  const mainQuestions = questionnaire.filter(question => question.idQuestion === mainIdQuestion);
  for (const mainQuestion of mainQuestions) {
    let group = []

    const mainQuestionIndex = questionnaire.findIndex(question => question.idQuestion === mainIdQuestion);
    if (mainQuestionIndex || mainQuestionIndex == 0) group.push(questionnaire[mainQuestionIndex]);

    if (mainQuestionIndex != -1) questionnaire.splice(mainQuestionIndex, 1);

    if (mainQuestion.childrenQuestions) mainQuestion.childrenQuestions.map(childQuestion => group.push(childQuestion));

    group.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

    if (handleQuestionsInitialAdjustments) group = handleQuestionsInitialAdjustments({ questionnaire: group, permissions });

    groupQuestions.push(group.map((question, index) => ({ ...question, key: null })));
  }

  return groupQuestions;
}

function sectionIsVisible({
  sectionName,
  questionnaire,
  permissions = {},
  currentModality,
  ignoreVisibilityByModality = false
}) {
  const permissionsValues = Object.values(permissions);

  return questionnaire
    .some(question => question?.behaviorObject?.sectionName === sectionName
      && question.visibleQuestion
      && (ignoreVisibilityByModality || !question.productPlans?.length || question.productPlans.includes(currentModality))
      && (
        !question?.behaviorObject?.idDomainAccessFilter ||
        !permissionsValues ||
        (!Array.isArray(question?.behaviorObject?.idDomainAccessFilter) ?
          permissionsValues.includes(question.behaviorObject.idDomainAccessFilter) :
          permissionsValues.find(v => v && question?.behaviorObject?.idDomainAccessFilter.includes(v))
        )
      )
    )
}

function createSectionRow({
  questions
}) {
  questions = JSON.parse(JSON.stringify(questions));
  return questions.map(question => {
    const { defaultValue } = question.behaviorObject || {};
    question.answer = defaultValue || "";
    question.answerJson = defaultValue || "";
    question.idAnswerOption = null;
    question.idPerson = null;
    question.idQuestionnaireAnswers = null;
    question.idQuestionnaireAnswersParent = null;
    question.idQuestionnaireAnswersRoot = null;
    question.key = null;

    if (question.behaviorObject?.extraExclamationWarning) {
      question.behaviorObject.extraExclamationWarning = false;
    }

    return question;
  })
}

async function serproRequest({
  searchValue,
  token,
  idOperation
}) {
  const mc = new MessageCenter();
  const fitinsurApi = new FitinsurAPI();

  try {
    fitinsurApi.setAuthToken(token);
    let data = await fitinsurApi.requestSerproCnpj(searchValue, true, idOperation).then(v => v.json())

    if (data.ret_code !== 200) {
      data.ret_value.trim() === "Nenhum registro encontrado."
        ? mc.error(`${data.ret_value}`)
        : mc.error("Erro durante a Consulta do CNPJ/CPF")
      return null;
    }

    return data.ret_value
  } catch (err) {
    console.log("error serpro", err)
    mc.error(`Erro durante a Consulta do CNPJ/CPF`);
    return null;
  };
}

function onValidationError(e, mc, formikRef, questionnaire, groupQuestionnaires) {
  console.log('onValidationError catch initial', e)

  questionnaire = cloneDeep(questionnaire);
  groupQuestionnaires = cloneDeep(groupQuestionnaires);

  mc.error('Por favor, preencha todos os campos obrigatórios para prosseguir.')
  const allQuestions = questionnaire;

  groupQuestionnaires.forEach((grpQuestionnaire) => {
    Array.isArray(grpQuestionnaire)
      ? grpQuestionnaire.map(question => allQuestions.push(question))
      : grpQuestionnaire.questions.map(question => allQuestions.push(question))
  });

  let firstErrorKey = null;
  try {
    for (const question of allQuestions) {
      if (!formikRef.current.errors || !formikRef.current.errors[question.key]) continue;
      formikRef.current.setFieldError(question.key, null);
    }

    e.inner.map(({ message, path }) => {
      const question = allQuestions.find(question => question.key === path);

      if (message.includes('CPFCNPJ')) {
        mc.error('OS campos CPF/CNPJ não podem conter valores duplicados.');
        formikRef.current.setFieldError(question.key, `* CPF/CNPJ duplicados`)
      } else {
        if (question.dsQuestion === "E-mail") {
          mc.error(`O e-mail inserido é inválido`);
          formikRef.current.setFieldError(question.key, `* E-mail inválido`);
        } else {
          mc.error(`O Campo: ${question.dsQuestion} é Obrigatório`);
          formikRef.current.setFieldError(question.key, `* Campo Obrigatório`);
        }
      }

      if (!firstErrorKey) firstErrorKey = question.key;
    });

    if (firstErrorKey) {
      const elements = global.window.document.getElementsByName(firstErrorKey);
      if (elements?.length) {
        setTimeout(() => elements[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' }), 300);
      }
    }
  } catch (e) {
    console.log('onValidationError catch', e)
  }
}

const events = {
  handleInitialAdjustments,
  groupMultipleFieldQuestions,
  sectionIsVisible,
  createSectionRow,
  serproRequest,
  onValidationError
}

export { events };
